module.exports = __webpack_public_path__ + "static/img/introduction.131f7d7d.png";